/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      // How far (in px) below the screen the next batch should start loading. Increase for earlier loading.
      this.preload_distance = 4000;
      // Total number of pages (set from pagination.liquid). 0 = unknown.
      this.total_pages = parseInt(this.dataset.pages, 10) || 0;
      this.finished = false;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function() {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      // Fire as soon as the loader is within `preload_distance` px below the visible screen
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          base.loadProducts();
        }
      }, {
        rootMargin: '0px 0px ' + base.preload_distance + 'px 0px'
      });
      const start = function() {
        base.observer.observe(base);
      };
      if (document.readyState === 'complete') {
        start();
      } else {
        window.addEventListener('load', start, { once: true });
      }
    }
    loadProducts() {
      let base = this,
        params = base.addUrlParam(document.location.search, 'page'),
        url = document.location.pathname + params + (params.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(base.dataset.section);
      if (base.finished || base.getAttribute('loading')) {
        return;
      }
      if (base.total_pages && base.i > base.total_pages) {
        base.finish();
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        })
        .catch(() => {
          base.removeAttribute('loading');
        });
    }
    finish() {
      this.finished = true;
      this.removeAttribute('loading');
      if (this.observer) {
        this.observer.unobserve(this);
      }
      if (this.button) {
        this.button.classList.add('visually-hidden');
      }
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        base.finish();
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      if (products.length === 0) {
        base.finish();
        return;
      }

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05
        });
      }

      // Allow the next batch to start right away (don't wait for the animation to end)
      if (base.total_pages && base.i > base.total_pages) {
        base.finish();
        return;
      }
      base.removeAttribute('loading');

      // Re-check: if the loader is still within the preload distance, load the next batch immediately
      if (base.observer) {
        base.observer.unobserve(base);
        base.observer.observe(base);
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
